import { Timestamp } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { SubTitleRendererParams } from '../../subTitleRenderers';

export function conversationTimelineSubTitleRenderer(
  params: SubTitleRendererParams,
) {
  const { metaConversation } = params;
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt } = conversation;

  return (
    <>
      {lastMessageCreatedAt && (
        <>
          <span
            onClick={() =>
              ampli.conversationsTimestampClicked({
                context: 'created',
              })
            }
          >
            <Timestamp time={lastMessageCreatedAt} />
          </span>
        </>
      )}
    </>
  );
}
